import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const InviteFriendsComponent = lazy(() => import('components/Sections/InviteFriends'))
const Footer = lazy(() => import('components/Layout/Footer'))

function InviteFriends() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <InviteFriendsComponent />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default InviteFriends